import { render, staticRenderFns } from "./GestionNoConformidades.vue?vue&type=template&id=70657070&"
import script from "./GestionNoConformidades.vue?vue&type=script&lang=js&"
export * from "./GestionNoConformidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports